import { forwardRef } from 'react'
import { useTheme } from '../../hooks/useTheme'
import type { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  onClick?: () => void
  className?: string
  showArrow?: boolean
  variant?: 'default' | 'brand' | 'overlap'
  noHover?: boolean
}

export const Card = forwardRef<HTMLDivElement, CardProps>(({
  children,
  onClick,
  className = '',
  showArrow = false,
  variant = 'default',
  noHover = false,
}, ref) => {
  const theme = useTheme()
  
  const variantStyles = {
    default: {
      backgroundColor: theme.cardBg,
      border: `1px solid ${theme.cardBorder}`,
    },
    brand: {
      backgroundColor: theme.cardBg,
      border: `1px solid ${theme.cardBorder}`,
      boxShadow: onClick ? theme.shadow.card : undefined,
    },
    overlap: {
      backgroundColor: theme.isDark ? 'rgba(0, 136, 204, 0.08)' : 'rgba(0, 136, 204, 0.05)',
      border: `2px solid ${theme.accent.border}`,
    },
  }
  
  return (
    <div
      ref={ref}
      className={`rounded-xl p-4 flex flex-col gap-2 transition-all ${
        onClick ? `cursor-pointer active:scale-[0.98]${noHover ? '' : ' hover:opacity-90 hover:scale-[1.01]'}` : 'cursor-default'
      } relative ${className}`}
      style={variantStyles[variant]}
      onClick={onClick}
    >
      {showArrow && onClick && (
        <span className="absolute top-4 right-4 text-xl opacity-50 flex-shrink-0">
          →
        </span>
      )}
      {children}
    </div>
  )
})

Card.displayName = 'Card'
